<input
  #input
  type="color"
  class="form-control"
  required
  maxlength="30"
  (change)="inputChanged()"
  [formControl]="value" />
